import { render, staticRenderFns } from "./ChatFansTransfer.vue?vue&type=template&id=12efbb0c&"
import script from "./ChatFansTransfer.vue?vue&type=script&lang=js&"
export * from "./ChatFansTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ChatFansTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports